module.exports = __webpack_public_path__ + "img/7.d8180f04.jpg";